module.exports = __webpack_public_path__ + "img/chocolate_bunny.967323fd.jpg";